import { Moment } from "moment";
import { DateFormat } from "../../../../../../constants";
import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form26 = (record: any) => {
  return {
    departmentCode: "1",
    aflType: AFLType.AccidentNotification,
    layout: [
      {
        type: "header",
        value: {
          form: 1,
          department: StringHelper.verticalBarSplit(record?.eDepartment)[1],
        },
      },
      {
        type: "title",
        value: {
          sub: [],
        },
      },
      {
        type: "salutation",
        value: [
          "Tổng Giám đốc",
          `Trưởng phòng ${StringHelper.verticalBarSplit(record?.eUnit)[1]};`,
          "Trưởng phòng Tổ chức và Nhân lực.",
        ],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          { type: "eEmployeeId", value: record?.eEmployeeId },
          {
            type: "eWorkPlaceTeam",
            value: StringHelper.verticalBarSplit<string[]>(record?.eTeam)[1],
          },
          {
            type: "eWorkPlaceDepartment",
            value: [
              StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
              StringHelper.verticalBarSplit<string[]>(record?.eDepartment)[1],
            ],
          },
          {
            type: "",
            value:
              "Nay tôi kính thông báo đến Ông Tổng Giám đốc, Trưởng phòng, Đội trưởng về việc tai nạn rủi ro/tai nạn giao thông với nội dung như sau:",
          },
          {
            type: "eAccidentTime2",
            value: (record?.eAccidentTime as Moment).format(
              DateFormat.DD_MM_YYYY
            ),
          },
          { type: "eAccidentLocation", value: record?.eAccidentLocation },
          { type: "eAccidentReason", value: record?.eReason || "" },
          { type: "eStatus", value: record?.eStatus },
          {
            type: "",
            value:
              "Rất mong nhận được sự chấp thuận của Ông Tổng Giám đốc, Trưởng phòng, Đội trưởng.",
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["TRƯỞNG PHÒNG TCNL", record?.eApprovalProcess[3][0].name],
          },
          {
            type: "signature1",
            value: ["THỦ TRƯỞNG ĐƠN VỊ", record?.eApprovalProcess[1][0].name],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", "- Lưu TCNL."],
          },
          {
            type: "signature1",
            value: [
              "PHÊ DUYỆT CỦA TỔNG GIÁM ĐỐC",
              record?.eApprovalProcess[4][0].name,
            ],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
